import { GetStaticProps } from 'next'

import photoCopy from '@/data/fixed-pages/copy-photo'

import PagePhoto, { PagePhotoProps } from '@/components/PagePhoto/PagePhoto'

export const getStaticProps: GetStaticProps<PagePhotoProps> = async () => {
  return {
    props: {
      head: { title: 'Photo' },
      content: photoCopy
    }
  }
}

export default PagePhoto
